<template>
  <div class="middle">
    <navigation :customClickEvent="true" @click="detention">优选借款</navigation>
    <div class="animation-wapper" v-if="showGif">
      <lottie ref="animataion" :options="showGif" v-on:animCreated="handleAnimation"/>
    </div>
    <div class="text1">已为您匹配优质借款</div>
    <div class="text2">您的借款来自以下产品</div>
    <main>
      <img :src="logo" class="icon"/>
      <div class="icon-name">{{productName}}</div>
      <div class="fail-button" @click="dealJump">立即前往 <span v-show="time" v-if="prInfo.autoJump">({{time}}s)</span></div>
    </main>
    <div class="protocol">
      <span class="text" v-if="diversionMode==='U'">
        我们非常重视您的隐私及个人信息保护，<b>使用本服务我们会将您授权我们收集的手机号码授权给上述产品，如不同意请点击左上方返回按钮暂停使用本服务。</b>具体请参考<a class="highlight" @click='routerToProtocol("/tmd/protocol/login")'>《天美贷用户注册及服务协议》</a>
        <a class="highlight" @click='routerToProtocol("/tmd/protocol/privacy")'>《天美贷隐私政策》</a>
      </span>
      <span class="text" v-if="diversionMode==='H'">
        我们非常重视您的隐私及个人信息保护。使用服务前，请您认真阅读<a class="highlight" @click='routerToProtocol("/tmd/protocol/login")'>《天美贷用户注册及服务协议》</a>
        <a class="highlight" @click='routerToProtocol("/tmd/protocol/privacy")'>《天美贷隐私政策》</a>
      </span>
    </div>
    <!-- 返回弹窗 -->
    <nd-dialog v-model="toBack" :footer="false" closeBtn>
      <div class="logout-dialog1">
        <div class="tong-guo">你已通过该产品初审</div>
        <div class="main">
          <div class="middle1">
            <img :src="riverDataBack.icon" class="middle1-img">
            <span class="middle1-productName">{{riverDataBack.productName}}</span>
            <div class="middle1-cornerWord" v-if="riverDataBack.cornerWord">{{riverDataBack.cornerWord}}</div>
          </div>
          <div class="e-du-gao-da">额度高达<span class="red">{{riverDataBack.configLimit|toFixed}}</span>万 </div>
          <div class="nian-hua-li-lv">年化利率 {{riverDataBack.minPrice}}%-{{riverDataBack.maxPrice}}%</div>
        </div>
        <div class="seize" @click="goToFailBack">抓住机会</div>
        <div class="give-up" @click="back">我不想要钱了</div>
      </div>
    </nd-dialog>
  </div>
</template>

<script>
import Lottie from 'vue-lottie'
import { wait } from '@/assets/json/index'
import { mapActions } from 'vuex'
import { setKey, judgeClientSystem } from '@/assets/utils'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'

export default {
  name: 'river-middle',
  customReadyNotify: true,
  components: {
    'lottie': Lottie
  },

  data () {
    return {
      showGif: { animationData: wait },
      productName: this.$route.query.productName || '', // 图标名称
      configLimit: this.$route.query.configLimit || '', // 传入的金额
      needExLogin: this.$route.query.needExLogin === 'true', // 是否需要展示协议
      toBack: false, // 返回弹窗
      logo: this.$route.query.logo || {},
      riverData: {},
      riverDataBack: {},
      time: 3,
      prInfo: {},
      diversionMode: '',
      isReady: false // 已经获取数据完成
    }
  },
  beforeDestroy () {
    clearTimeout(window.timer)
  },
  async created () {
    const { configId } = this.$route.query || {}
    if (!configId) {
      return this.backHome()
    }
    await this.addEvent({
      configId: configId,
      bizType: 'diversion'
    })
    const { success, data } = await this.getProductInfo({
      configId
    })
    if (success) {
      this.prInfo = data
    }
    this.$report({
      id: 10002,
      args: { screen: 'river_diversion_middle', target: configId }
    })
    this.init()
    this.$bus.$emit('ready')
  },

  watch: {
    toBack (value) {
      const { configId } = this.riverDataBack || {}
      this.$report({
        id: 10292,
        args: { position: 'page_river_middle', visible: value ? 1 : 0, screen: 'page_river_middle', target: configId }
      })
      if (!value) {
        this.goToResult()
      }
    }
  },
  methods: {
    ...mapActions('user', ['exLogin', 'getBorrowList', 'addEvent']),
    ...mapActions('apiDiversion', ['getProductInfo']),
    ...mapActions(['dataPoint']),
    backHome () {
      if (hasNativeMethod('navigateTo') && judgeClientSystem() !== 'IOS') {
        jsBridge('exit')
      } else {
        this.$router.go(-1)
      }
    },
    // 失败申请
    goToFailBack () {
      const { configId, directionUrl, productName, configLimit, logo, needExLogin } = this.riverDataBack || {}
      this.$report({
        id: 10293,
        args: {
          screen: `page_river_middle`, status: 'try', target: configId
        }
      })
      this.dataPoint(
        {
          id: 10293, screen: `page_river_middle`, status: 'try', target: configId
        }
      )// 同步埋点
      let url = `${location.pathname}`
      url += `?directionUrl=${directionUrl}&configId=${configId}&productName=${productName}&logo=${logo}&configLimit=${configLimit}&needExLogin=${needExLogin}`
      this.source && (url += `&source=${decodeURIComponent(this.source)}`)
      history.pushState({ url: url }, '', url)
      window.location.reload()
    },
    // 联登
    init () {
      const { diversionMode, autoJump } = this.prInfo
      this.diversionMode = diversionMode
      if (['A', 'AF'].includes(diversionMode)) {
        return this.dealJump()
      }
      if (autoJump) {
        this.timeOut()
      }
    },
    timeOut () {
      if (this.time > 0) {
        window.timer = setTimeout(() => {
          this.time--
          this.timeOut()
        }, 300)
      } else {
        this.dealJump()
        clearTimeout(window.timer)
      }
    },
    // 获取并处理处理接口数据
    async dealJump () {
      const { configId, logo, configLimit, needExLogin, to, needQueue, applyNo, from } = this.$route.query || {}

      const { source } = this.$route.query || {}
      let sourceData = source ? { source } : {}
      const { productName } = this
      const response = await this.exLogin({ configId })
      setKey('river-index', 0)
      let type = ''
      const { code, url, jumpType, diversionSerialNo, autoJump } = response.data || {}
      if (response.success) {
        if (code === 'SUCCESS') {
          type = 'success'
        } else {
          type = 'fail'
        }
      } else {
        type = 'unusual' // 系统异常
      }
      let urlArr = url ? { directionUrl: encodeURIComponent(url) } : {}
      this.riverData = { productName, type, logo, configId, configLimit, needExLogin, ...sourceData, ...urlArr, to, from, needQueue, applyNo, autoJump }
      if (!configId) {
        localStorage.removeItem('configIds')
      }

      this.isReady = true
      /**
       * 跳转类型
       * DIVERSION_CREDIT_APPLY 跳api转授信申请页
       * DIVERSION_CREDIT_RESULT 跳api转授信结果页
       * DIVERSION_ACCESS_FAIL 跳api转撞库失败页面
       * R_360_FROM 融360表单
       * OLD_PAGE 老流程页面
       */
      if (jumpType === 'DIVERSION_CREDIT_APPLY') {
        setKey('configIds', [configId])
        this.$router.replace({
          path: '/authentication/api-auth'
        })
      } else if (jumpType === 'DIVERSION_CREDIT_RESULT') {
        setKey('configIds', [configId])
        this.$router.replace({
          path: '/authentication/api-result',
          query: {
            applyNo: diversionSerialNo
          }
        })
      } else if (jumpType === 'R_360_FROM') {
        setKey('configIds', [configId])
        this.$router.replace({
          path: '/authentication/api-base-360'
        })
      } else if (jumpType === 'DIVERSION_ACCESS_FAIL') {
        this.goToResult(false)
      } else {
        this.goToResult(response.success)
      }
    },
    goToResult (success) {
      if (!this.toBack && this.isReady) {
        this.$router.replace({ path: '/river/result', query: { ...this.riverData, version: this.$route.query.version } })
      }
    },
    handleAnimation (anim) {
      this.anim = anim
    },
    // 点击返回
    async detention () {
      const response = await this.getBorrowList({ showPlace: 'ALL', queryBanner: true, dialog: true, queryChannel: 1, version: 'V2' })
      if (response.success) {
        const { configs } = response.data
        if (configs && configs.length > 0) {
          let arr = configs || []
          this.riverDataBack = arr[0] || {}
          this.toBack = true
        } else {
          this.back()
        }
      } else {
        this.back()
      }
    },
    // 确认返回
    back () {
      const { to, applyNo, needQueue, from } = this.$route.query
      if (to && hasNativeMethod('exit') && judgeClientSystem() !== 'IOS') {
        jsBridge('exit')
        return
      }
      if (to && applyNo) {
        if (needQueue) {
          this.$router.replace(
            `/authentication/wait?applyNo=${applyNo}`
          )
        } else {
          this.$router.replace(
            `/authentication/result?applyNo=${applyNo}`
          )
        }
        return
      }
      if (from === 'pre-base') {
        this.$router.go(-1)
        return
      }
      let sourceData = this.source ? { source: decodeURIComponent(this.source) } : {}
      const version = this.$route.query.version
      this.$router.replace({ path: version === 'v2' ? '/river/diversion2' : '/river/diversion', query: { ...sourceData } })
    },
    routerToLoginProtocol () {
      this.$report({
        id: 10270,
        args: { position: 1 }
      })
      this.$router.push('/river/diversion/protocol')
    }
  }
}
</script>

<style scoped lang="less">
@import "../../../assets/less/mixin.less";

.middle{
  width: 750px;
  height: 100%;
  background: #FAFAFA;
  .text1{
    text-align: center;
    padding-top:57px;
    font-size: 36px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
  }
  .text2{
    padding-top:8px;
    text-align: center;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
  .animation-wapper {
    height: 210px;
    width: 210px;
    margin: 152px auto 0;
  }
  main{
    margin-top:94px;
    display: flex;
    align-items:center;
    flex-direction:column;
    .icon{
      width:140px;
      height:140px;
      border-radius: 20px;
    }
    .icon-name{
      margin-top:22px;
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }
  }
  .fail-button{
    width: 320px;
    height: 80px;
    line-height: 80px;
    background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
    border-radius: 40px;
    text-align: center;
    font-size: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    margin:31px auto 0;
  }
  .protocol {
        line-height: 32px;
        font-size: 24px;
        padding: 40px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999;
     b{color: #333;}
        a {
            color: #8eb2d8;
        }
  }
  .logout-dialog {
      padding-top: 10px;
      padding: 0 48px;
      padding-bottom: 40px;
      font-family: PingFangSC-Regular,PingFang SC;
      .title {
          width: 380px;
          font-size: 38px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          margin: auto;
          text-align:center;
      }
      .description {
          text-align: center;
          width: 454px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          margin:41px auto 0;
      }
      .give-up{
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        margin-top:22px;
        text-align:center;
      }
      .seize{
        width: 440px;
        height: 80px;
        background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
        border-radius: 40px;
        font-size: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        text-align:center;
        margin:150px auto 0;
        line-height: 80px;
      }
  }
  .logout-dialog1 {
      padding: 60px 0 39px;
      font-family: PingFangSC-Regular,PingFang SC;
      .tong-guo{
        text-align:center;
        font-size: 36px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
      }
      .main{
        padding:0 0 0 90px;
        font-family: PingFangSC-Medium, PingFang SC;
        .middle1{
        display:flex;
        align-items:center;
        margin:84px 0 0 0;
        &-img{
            width: 48px;
            height: 48px;
            border-radius:10px;
        }
        &-productName{
            height: 40px;
            font-size: 28px;
            font-weight: 500;
            color: #333333;
            line-height: 40px;
            margin-left:12px;
            max-width:300px;
            overflow: hidden;//溢出隐藏
            white-space: nowrap;//禁止换行
            text-overflow: ellipsis;//...
        }
        &-cornerWord{
            padding:4px 10px;
            border-radius: 4px;
            border: 1px solid #FF4633;
            line-height:34px;
            text-align: center;
            font-size: 22px;
            font-weight: 400;
            color: #FF4633;
            margin-left:15px;
        }
      }
      .e-du-gao-da{
          height: 92px;
          font-size: 66px;
          font-weight: 500;
          color: #333333;
          line-height: 92px;
          margin-top:19px;
          width: 410px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
      }
      .nian-hua-li-lv{
          height: 33px;
          font-size: 24px;
          font-weight: 400;
          color: #666666;
          line-height: 33px;
      }
      .red{
          color:#FF4633;
      }
      }
      .give-up{
        font-size: 24px;
        font-weight: 400;
        color: #999999;
        margin-top:38px;
        text-align:center;
      }
      .seize{
        width: 440px;
        height: 80px;
        background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
        border-radius: 40px;
        font-size: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        text-align:center;
        margin:69px auto 0;
        line-height: 80px;
      }
  }
}
</style>